import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { http } from "@/lib/api";
import { useProfile } from "@/context/ProfileContext";

let lastActive = Date.now();
export const markActive = () => { lastActive = Date.now(); };

const IDLE_MS = 3 * 60 * 1000;
const TICK = 5;
const FLUSH = 30;
const EVENTS = ["mousemove", "keydown", "scroll", "touchstart", "click"];
const areaFor = (path, tutor) =>
  tutor ? "tutor" : path.startsWith("/learn") ? "lesson" : path.startsWith("/journal") ? "journal" : null;

export const SeatTimeTracker = () => {
  const { profile, tutorOpen } = useProfile();
  const { pathname } = useLocation();
  const area = useRef(null);
  area.current = areaFor(pathname, tutorOpen);

  useEffect(() => {
    EVENTS.forEach((e) => window.addEventListener(e, markActive, { passive: true }));
    return () => EVENTS.forEach((e) => window.removeEventListener(e, markActive));
  }, []);

  useEffect(() => {
    if (profile?.role !== "student") return;
    const acc = {};
    const flush = (a) => {
      const s = acc[a];
      if (!s) return;
      acc[a] = 0;
      http.post("/activity", { area: a, seconds: s }).catch(() => {});
    };
    const id = setInterval(() => {
      const a = area.current;
      if (!a || document.visibilityState !== "visible" || Date.now() - lastActive > IDLE_MS) return;
      acc[a] = (acc[a] || 0) + TICK;
      if (acc[a] >= FLUSH) flush(a);
    }, TICK * 1000);
    const onHide = () => { if (document.visibilityState === "hidden") Object.keys(acc).forEach(flush); };
    document.addEventListener("visibilitychange", onHide);
    return () => {
      clearInterval(id);
      document.removeEventListener("visibilitychange", onHide);
      Object.keys(acc).forEach(flush);
    };
  }, [profile?.role]);

  return null;
};
